import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: {
        id: string
    }
}

const { onRequest, onSuccess, onFailure } = rootActions.contacts.oneContact
function* oneContactSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/contacts/one/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneContactSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneContactSagaTask)
}

export default oneContactSaga
